import type { ApiResult } from './types';

const TOKEN: string = (() => {
  const p = new URLSearchParams(window.location.search);
  return p.get('token') ?? '';
})();

export function token(): string {
  return TOKEN;
}

function withToken(path: string): string {
  if (!TOKEN) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}token=${encodeURIComponent(TOKEN)}`;
}

async function request<T>(
  method: 'GET' | 'POST',
  path: string,
  body?: unknown,
): Promise<T> {
  const init: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(TOKEN ? { Authorization: `Bearer ${TOKEN}` } : {}),
    },
  };
  if (body !== undefined) init.body = JSON.stringify(body);
  const res = await fetch(withToken(path), init);
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`${res.status}: ${text}`);
  }
  const json = (await res.json()) as ApiResult<T>;
  if (json.status === 'error') {
    throw new Error(json.error ?? 'unknown error');
  }
  return json.data;
}

export function apiGet<T>(path: string): Promise<T> {
  return request<T>('GET', path);
}

export function apiPost<T>(path: string, body: unknown): Promise<T> {
  return request<T>('POST', path, body);
}
